module.exports = {
      id: "icon-apple-usage",
      viewBox: "0 0 13.204 15.712",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-apple",
      toString: function () {
        return this.url;
      }
    }